
export const LeftHeaderWithButton = {
    paddingTop: '10px'
};

export const RightHeaderWithButton = {
    marginTop: '5px',
    paddingTop: '5px',
    paddingBottom: '6px'
};

export const FiltersOnStyle = {
    top: '2px',
    paddingTop: '5px',
    paddingBottom: '6px'
};

export const IconHeader = {
    fontSize: '9px'
};

export const IconRight = {
    fontSize: '14px',
    float: 'right'
};

export const HeaderCursor = {
    cursor: 'pointer'
};
export const IconHeaderP = {
    fontSize: '12px'
};



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/css.js